import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Nav, Container, Row, Col, Button, Modal, Spinner } from 'react-bootstrap';
import config from 'react-global-configuration';
import axios from 'axios';
import toastr from "toastr";

import data from '../../static/data/resultado_midia.json';

function ReportMidias({ dados, reportData }) {

    const [showModal, setShowModal] = useState(false);
    const [load, setLoad] = useState(false);
    const [activeData, setActiveData] = useState();
    const [activeIndex, setActiveIndex] = useState();
    const [rowData, setRowData] = useState(null);

    const dateFormat = (param) => param.value != '' ? new Date(param).toLocaleDateString("pt-br") + " " + new Date(param).toLocaleTimeString("pt-br") : '-';

    const getData = async () => {
        setLoad(true);
        try {
            // reportData[0].data_relatorio = '2025-03-17 14:51:39';
            // reportData[0].doc_number = '17170150000146';
            // https://api.dev.esgscan.com.br/news?contract_id=FAB-0003&customercnpj=06019237664&documento=17170150000146&data_relatorio=2025-03-17 14:51:39&assunto=midias_negativas
            // const url = config.get('urlbase') + '/news?contract_id=' + JSON.parse(localStorage.getItem('userInfos')).data.contract_id + '&customercnpj=' + JSON.parse(localStorage.getItem('userInfos')).data.customercnpj + '&data_relatorio=' + reportData[0].data_relatorio + '&documento=' + reportData[0].doc_number + '&assunto=midias_negativas';
            const url = config.get('urlbase') + '/news?contract_id=FAB-0003&customercnpj=06019237664&documento=17170150000146&data_relatorio=2025-03-17 14:51:39&assunto=midias_negativas';
            const headers = { 'x-api-key': JSON.parse(localStorage.getItem('userInfos')).data.Token };
            const data = (await axios.get(url, { headers })).data;
            if (data && data.Item && data.Item.Midias) {
                if (data.Item.Midias.length > 0) {
                    setRowData(data.Item.Midias);
                } else {
                    setRowData([]);
                }
            }
            if (data && data.statusCode && data.statusCode === 232) {
                setRowData([]);
            }
            setLoad(false);
        } catch (error) {
            setLoad(false);
            console.log(error);
            if (error.response.status === 404) {
                setRowData([]);
            } else {
                if (error.response.status === 403) {
                    setRowData([]);
                } else {
                    toastr.error('Erro ao listar mídias negativas');
                }
            }

        }
    }

    useEffect(() => {
        getData();
    }, []);

    const handleClickInfo = (index) => {
        setActiveIndex(index);
        setActiveData(rowData[index]);
        setShowModal(true);
    }

    return (
        <>
            {!load && rowData && rowData?.length > 0 &&
            <span className="fs-6">Foram identificadas <b className="fs-5">{rowData?.length} mídias negativas</b></span>}
            <Row className='d-flex scrollbar mt-3 pt-4' style={{ height: 'calc(100vh - 560px)' }}>
                {load &&
                    <Row className='d-flex justify-content-center mt-3'>
                        <Spinner animation="border" variant="success" />
                    </Row>
                }
                {rowData && rowData?.length > 0 ? rowData.map((item, index) =>
                (
                    <Col md={8} key={index}>
                        <div className='rect-content-risks w-100' style={{ height: "auto" }}>
                            <div className='rect-header'>
                                <div className={'rect-tag small inmodal ' + item.Esfera.replace('ç', 'c').toLowerCase()}>{item["Esfera"]}</div>
                            </div>
                            <div className='rect-tx-value'>Peso: {item["Peso"]}</div>

                            <p className='fs-5'><b>{item["Fonte"]}</b> <span className='fs-6'>{dateFormat(item["Data"])}</span></p>
                            <p className='rect-tx-1 fs-6' style={{ lineHeight: "22px" }}>
                                {item["Titulo"]} <br />
                                <span className='rect-tx-value fs-6' style={{ lineHeight: "22px" }}>{item["Categorias"].map((cat, i) => (item["Categorias"].length > 0 && i + 1 != item["Categorias"].length ? cat + " / " : cat))}</span><br />
                                <a href={item["Link"]} target='blank' className='rect-tx-value' style={{ lineHeight: "22px", fontSize: "12px" }}>{item["Link"]}</a>
                            </p>

                            <div className='rect-link cursor-pointer' onClick={() => handleClickInfo(index)}><i className="bi bi-plus-circle-fill"></i></div>
                        </div>
                    </Col>
                )) :
                    !load &&
                    <span className="fs-6">Nenhuma mídia negativa encontrada</span>
                }
            </Row>



            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes da Mídia</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {activeData ? (
                        <>
                            <div className="d-flex justify-content-between mb-3"><div className={'rect-tag small inmodal ' + activeData.Esfera.replace('ç', 'c').toLowerCase()}>{activeData["Esfera"]}</div><div className="rect-tx-value fs-5">Peso: {activeData["Peso"]}</div></div>

                            <p className='fs-5'><b>{activeData["Fonte"]}</b> <span className='fs-6'>{dateFormat(activeData["Data"])}</span></p>
                            <p className='rect-tx-1 fs-6' style={{ lineHeight: "22px" }}>
                                {activeData["Titulo"]} <br />
                                <span className='rect-tx-value fs-6' style={{ lineHeight: "22px" }}>{activeData["Categorias"].map((cat, i) => (activeData["Categorias"].length > 0 && i + 1 != activeData["Categorias"].length ? cat + " / " : cat))}</span><br />
                                <a href={activeData["Link"]} target='blank' className='rect-tx-value' style={{ lineHeight: "22px", fontSize: "12px" }}>{activeData["Link"]}</a>
                            </p>

                            <Row className='scrollbar d-flex mb-5' style={{ height: 'calc(100vh - 680px)' }}>
                                <div className='p-20' dangerouslySetInnerHTML={{ __html: activeData["Texto"].replace("\n\n", "<br /><br />") }}></div>
                                {/* <div className='p-20'> {activeData["Texto"].replace("\n\n", "<br /><br />")}</div> */}
                            </Row>

                            {activeData['Frameworks'] && Object.keys(activeData['Frameworks'])?.length > 0 && Object.keys(activeData['Frameworks']).map((item, index) => (
                                activeData['Frameworks'][item] !== ' - ' &&
                                <Row key={index}>
                                    <p className='mb-1'><b>{item}</b> {activeData['Frameworks'][item]}</p>
                                </Row>
                            ))}
                            {/* <p title="ODS: 17.1" className='mb-1'><b>ODS: </b> 17.1</p>
                            <p title="GRI: 201-1; 201-3; 414-1" className='mb-1'><b>GRI: </b> 201-1; 201-3; 414-1</p>
                            <p title="ETHOS: 17; 18; 19; 26" className='mb-1'><b>ETHOS: </b>17; 18; 19; 26</p>
                            <p title="SUSEP (Circular 666/2022): art. 8º, V" className='mb-1'><b>SUSEP (Circular 666/2022): </b>art. 8º, V</p>
                            <p title="BACEN (Resolução 4557/2017): art. 38-A, V" className='mb-1'><b>BACEN (Resolução 4557/2017): </b>art. 38-A, V</p>
                             */}
                        </>

                    ) : (
                        <p>Carregando...</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='small' variant="secondary" onClick={(e) => setShowModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ReportMidias;